var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12875 11.9715C2.27427 12.0394 2.44345 11.9827 2.52845 11.8363L6.39563 5.13313C6.45826 5.02464 6.46204 4.88765 6.40539 4.77574C6.34873 4.66347 6.24047 4.59377 6.12308 4.59377H3.54212L4.502 0.438088C4.54072 0.270205 4.46234 0.0968141 4.31663 0.0284938C4.17187 -0.0394749 4.00161 0.0175016 3.91694 0.163752L0.0497514 6.86688C-0.0128756 6.97537 -0.0166569 7.11236 0.0399974 7.22427C0.0966517 7.33654 0.204911 7.40624 0.322302 7.40624H2.90326L1.94338 11.5619C1.90467 11.7298 1.98302 11.9032 2.12875 11.9715Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.82ea8f197acb12d6e3bbb89b52ac03a6.svg";
export { ForwardRef as ReactComponent };